import { useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ReactComponent as Close } from "./close.svg";

function HandleRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasHandled = useRef(false);

  const goToMain = () => {
    navigate("/");
  };

  useEffect(() => {
    if (hasHandled.current) return;
    hasHandled.current = true;
    navigate("/handle-purchase", { replace: true });
  }, [location.search]);

  return (
    <>
      <div className="root">
        <div className="logoContainer">
          <div className="logoSmaller" onClick={() => goToMain()}>
            <b>kfOne</b>
          </div>
          <div className="underLogoSmaller" onClick={() => goToMain()}>
            <b>Killing Floor 1 Server</b>
          </div>
        </div>

        <div className="purchaseDiv">
          <div className="titleText">
            <b>Thank you for claiming!</b>
          </div>
          <div className="helpDescription">
            <b>Have fun!</b>
          </div>
          <div className="purchaseBox">
            <div className="wholeText">
              <div className="listText">
                <Close className="closeMarkForm" onClick={goToMain}></Close>
              </div>
              <div className="perkDescr">
                Your claim has been completed and is usually processed
                <b> instantly</b>.
              </div>
              <div className="perkDescr">
                If you're already in-game, please wait for the map to change.
                Otherwise, join once your privileges appear on the{" "}
                <b>
                  <Link style={{ color: "inherit" }} to="/portal">
                    Portal page
                  </Link>
                </b>
                !
              </div>
            </div>
          </div>
        </div>
        <footer>
          <p>© {new Date().getFullYear()}</p>
        </footer>
      </div>
    </>
  );
}

export default HandleRedirect;
